{
  "error-unable-to-update-email-signature": "Unable to update email signature. Please try again later"
}
